<div class="modal" style="display: block" data-backdrop="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
<div class="modal-backdrop show"></div>
